import { gql } from '@apollo/client';

export const SECRETS_DATA = gql`
  query allSecrets {
    secrets {
      name
      description
      maskedSecret
      createDate
      author
    }
  }
`;

export const CREATE_SECRET = gql`
  mutation createSecret($name: ID!, $description: String!, $secretValue: String!) {
    createSecret(name: $name, description: $description, secretValue: $secretValue) {
      name
      description
      maskedSecret
      createDate
      author
    }
  }
`;

export const EDIT_SECRET = gql`
  mutation updateSecret($name: ID!, $description: String!, $secretValue: String!) {
    updateSecret(name: $name, description: $description, secretValue: $secretValue) {
      name
    }
  }
`;

export const EDIT_SECRET_DESCRIPTION = gql`
  mutation updateSecretDescription($name: ID!, $description: String!) {
    updateSecretDescription(name: $name, description: $description) {
      name
    }
  }
`;

export const DELETE_SECRET = gql`
  mutation deleteSecret($name: ID!) {
    deleteSecret(name: $name) {
      name
    }
  }
`;
